import dragonVideo from './openart-video_user_389QdKqD7M0GBn2T7KWyVSqOw4Z_1768635922655_1768635923478.mp4';
import coffeeShopVideo from './coffee_shop.mp4';
import parkVideo from './Park.mp4';
import louiseVideo from './louise.mp4';
import yukiVideo from './yuki.mp4';
import urbanNightVideo from './urban_night_stretch.mp4';

export const videoItems = [
  {
    src: dragonVideo,
    alt: "Dragon Warrior",
    ratio: "16:9",
    model: "Seedance 4.0",
    tools: "Text-to-video synthesis with cinematic motion controls",
    approach:
      "Engineered detailed prompt describing epic fantasy scene with dragon warrior in frozen landscape, utilizing dynamic camera movements and atmospheric effects for cinematic quality.",
    type: "video",
  },
  {
    src: coffeeShopVideo,
    alt: "Coffee Shop",
    ratio: "9:16",
    model: "Kling 2.6 Pro",
    tools:
      "Portrait-mode video generation with natural lighting simulation and video stitching",
    approach:
      "Focused prompt on warm interior scene composition, golden hour lighting effects, and subtle character animation to create authentic cafe atmosphere.",
    type: "video",
  },
  {
    src: parkVideo,
    alt: "Park",
    ratio: "9:16",
    model: "Kling 2.6 Pro",
    tools:
      "Portrait video with outdoor environment rendering and video stitching",
    approach:
      "Generated using natural outdoor scene parameters, autumn color palette, and character motion dynamics for realistic park setting with bokeh depth effects.",
    type: "video",
  },
  {
    src: louiseVideo,
    alt: "Louise",
    ratio: "9:16",
    model: "Veo 3.1 Fast",
    tools:
      "Portrait-oriented character animation with facial expression control",
    approach:
      "Utilized detailed character description with specific lighting conditions, natural hair movement physics, and subtle emotional expression rendering.",
    type: "video",
  },
  {
    src: yukiVideo,
    alt: "Yuki",
    ratio: "9:16",
    model: "Veo 3.1 Fast",
    tools:
      "Portrait video with smile animation and natural expression synthesis",
    approach:
      "Crafted prompt emphasizing genuine emotional expressions, soft lighting setup, and natural micro-movements for authentic human portrayal.",
    type: "video",
  },
  {
    src: urbanNightVideo,
    alt: "Urban Night",
    ratio: "16:9",
    model: "Veo 3.1 Fast",
    tools:
      "Cinematic wide-format generation with urban environment rendering using Google Flow Labs",
    approach:
      "Engineered cityscape prompt with night-time lighting, neon reflections, and time-lapse style motion for dramatic urban atmosphere.",
    type: "video",
  },
  // Add more video items here
];

export const galleryItems = [
  {
    src: "https://ik.imagekit.io/jeikuP/openart-image_dZOvIKY__3040x5504_1768362427091.webp",
    alt: "AI Generated Image",
    ratio: "9:16",
    prompt:
      "A detailed portrait of a young woman named Lena facing the camera directly. She has clear, symmetrical facial features with large green eyes, naturally arched eyebrows, a straight nose, and full lips. Her skin is smooth with a light olive complexion. She has shoulder-length dark brown hair parted slightly to the side, tucked behind one ear. The lighting is soft and even, highlighting her natural look without harsh shadows. She wears a simple white shirt, and the background is plain and neutral to emphasize her face clearly.",
  },
  {
    src: "https://ik.imagekit.io/jeikuP/a_tall_slender_female_warrior_with_long.jpeg",
    alt: "female-warrior",
    ratio: "9:16",
    prompt:
      "A tall, slender female warrior with long silver hair braided over one shoulder, piercing green eyes, and intricate tribal tattoos on her arms. She wears lightweight leather armor accented with silver and emerald details, equipped with a curved bow and a quiver of arrows on her back. Her expression is fierce yet calm, standing in a forest clearing with soft, dappled light filtering through the trees.",
  },
  {
    src: "https://ik.imagekit.io/jeikuP/extreme_closeup_hyperrealistic_shot_of_a_human.jpeg",
    alt: "human-eye",
    ratio: "16:9",
    prompt:
      "Extreme close-up hyper-realistic shot of a human eye. Visible veins in sclera, subtle moisture on lower eyelid, detailed iris fibers with natural color variation. Soft diffused studio lighting, macro lens realism, ultra-sharp focus. No digital painting look, true photographic realism.",
  },
  {
    src: "https://ik.imagekit.io/jeikuP/download%20(1).jpeg",
    alt: "watch",
    ratio: "9:16",
    prompt:
      "Hyper-realistic commercial product photo of a minimalist black wristwatch resting on dark volcanic stone. Fine scratches on metal casing, fingerprint smudges on glass, precise reflections. Dramatic studio lighting with soft key light and subtle fill, deep shadows. Shot on a macro lens, ultra-high resolution, sharp focus on dial texture. Clean professional advertising aesthetic, no CGI look, realistic physics and reflections.",
  },
  {
    src: "https://ik.imagekit.io/jeikuP/download%20(3).jpeg",
    alt: "fisherman",
    ratio: "9:16",
    prompt:
      "Hyper-realistic environmental portrait of an elderly fisherman repairing nets by the shore at sunrise. Deep facial wrinkles, sun-weathered skin, calloused hands in sharp detail. Golden hour lighting casting long shadows. Ocean mist in the background, realistic haze. Shot on a 50mm lens, natural color grading, documentary photography style, no artificial stylization.",
  },
  {
    src: "https://ik.imagekit.io/jeikuP/hyperrealistic_minimalist_wildlife_film_poster_featuring_a.jpeg",
    alt: "wildlife",
    ratio: "9:16",
    prompt:
      "Hyper-realistic minimalist wildlife film poster featuring a lone gray wolf standing in early morning fog. Detailed fur texture with individual strands visible, subtle moisture on the nose, visible breath in cold air. Soft dawn light casting gentle highlights along the fur. Natural posture, alert but calm expression. Shot on a telephoto lens, shallow depth of field. Muted natural color palette, subtle film grain, realistic print texture. Large negative space above the subject with only minimal title placeholder. No dramatic effects, no stylization.",
  },
  {
    src: "https://ik.imagekit.io/jeikuP/hyperrealistic_vertical_photo_collage_documenting_a_single.jpeg",
    alt: "city-panels",
    ratio: "9:16",
    prompt:
      "Hyper-realistic vertical photo collage documenting a single day in a city. Top panel: early morning street light. Middle panels: crowded market, close-up human detail. Bottom panel: quiet night street. Realistic lighting progression, consistent lens realism. Minimalist photojournalistic layout, no decorative graphics.",
  },
  {
    src: "https://ik.imagekit.io/jeikuP/download.jpeg",
    alt: "apartment",
    ratio: "9:16",
    prompt:
      "Ultra-realistic modern apartment interior at early morning. Soft sunlight entering through sheer curtains, realistic light diffusion and shadow gradients. Natural imperfections: slight fabric wrinkles, fingerprints on glass table, dust particles in light beams. Shot on a wide-angle lens with realistic perspective correction. Clean Scandinavian aesthetic, photoreal architectural photography.",
  },
  {
    src: "https://ik.imagekit.io/jeikuP/hyperrealistic_vertical_shot_of_a_cat_or%20(1).jpeg",
    alt: "cat",
    ratio: "9:16",
    prompt:
      "Hyper-realistic vertical shot of a cat or dog looking toward the camera, partially obscured by leaves in the foreground. Soft natural light filtering through leaves, creating subtle dappled shadows on fur. Slight motion blur on foreground foliage, shallow depth of field on animal’s eyes and face. Realistic fur texture, natural posture.",
  },
  {
    src: "https://ik.imagekit.io/jeikuP/hyperrealistic_topdown_shot_of_a_hand_reaching.jpeg",
    alt: "hand-cup",
    ratio: "1:1",
    prompt:
      "Hyper-realistic top-down shot of a hand reaching toward a coffee cup or smartphone floating slightly above a table. Subtle motion blur on hand, shallow depth of field on object. Realistic shadows on surface, soft ambient lighting. Minimalist background, tactile texture on hand, cup, or gadget. Angle gives dynamic tension like something’s mid-air.",
  },
  {
    src: "https://ik.imagekit.io/jeikuP/hyperrealistic_cinematic_lowangle_shot_of_a_superhero%20(1).jpeg",
    alt: "superhero",
    ratio: "16:9",
    prompt:
      "Hyper-realistic cinematic low-angle shot of a superhero standing on a rooftop, camera looking up from street level. Cape flowing, subtle wind movement, armor or suit detailed with scratches. Soft evening light casting long shadows upward, city skyscrapers in background. Slight motion blur for realism, grounded superhero realism (no floating, exaggerated limbs).",
  },
  {
    src: "https://ik.imagekit.io/jeikuP/hyperrealistic_cinematic_scene_of_explorers_approaching_a.jpeg",
    alt: "portal",
    ratio: "16:9",
    prompt:
      "Hyper-realistic cinematic scene of explorers approaching a glowing magical portal in overgrown ancient ruins. Stone structures cracked, moss and vines growing naturally. Portal emits subtle ethereal light in blue and gold, softly illuminating nearby stones and foliage. Mist and dust particles in air, soft beams of sunlight filtering through gaps in ruins. Camera: low-angle slightly behind explorers to emphasize portal’s scale. Textures: stone, moss, cloth of explorers, realistic lighting reflections. Depth of field: focus on portal, explorers slightly blurred. Grounded realism with fantasy elements.",
  },
  {
    src: "https://ik.imagekit.io/jeikuP/hyperrealistic_closeup_of_a_gourmet_burger_on%20(1).jpeg",
    alt: "burger",
    ratio: "9:16",
    prompt:
      "Hyper-realistic close-up of a gourmet burger on a wooden plate. Bun slightly toasted with visible sesame seeds, melted cheese dripping naturally, lettuce crisp, tomato slices with subtle water droplets. Juicy beef patty with realistic char marks. Soft side lighting highlighting texture and color, shallow depth of field blurring the background slightly. Realistic shadows on plate, ambient reflections on ingredients. No exaggerated saturation, no floating elements.",
  },
  {
    src: "https://ik.imagekit.io/jeikuP/hyperrealistic_cinematic_scene_of_a_coffee_cup.jpeg",
    alt: "coffee",
    ratio: "9:16",
    prompt:
      "Hyper-realistic cinematic scene of a coffee cup on a wooden table, next to a smartphone and notebook. Natural sunlight streaming through window, creating soft shadows. Realistic reflections on cup surface, paper texture visible. Slight motion blur on hand reaching for cup. Warm, inviting atmosphere. Minimalist but believable composition.",
  },
  {
    src: "https://ik.imagekit.io/jeikuP/hyperrealistic_cinematic_portrait_of_a_model_striking.jpeg",
    alt: "model",
    ratio: "9:16",
    prompt:
      "Hyper-realistic cinematic portrait of a model striking a confident fashion editorial pose. Outfit: tailored blazer, stylish trousers, boots. Pose: one shoulder slightly forward, hands relaxed, head angled slightly down with gaze to the side. Studio-style soft lighting with shadows defining body contours, high detail on fabric texture and hair. Minimalist background with shallow depth of field. No exaggerated angles, no floating limbs.",
  },
  {
    src: "https://ik.imagekit.io/jeikuP/hyperrealistic_cinematic_scene_of_a_colossal_dragon.jpeg",
    alt: "dragon",
    ratio: "16:9",
    prompt:
      "Hyper-realistic cinematic scene of a massive dragon flying low over an icy tundra, ridden by a knight raising his sword in preparation for battle. The dragon’s scales are textured with realistic ridges, scratches, and frost accumulation along edges. Muscles visibly flex under the skin as wings flap against wind resistance, wings slightly translucent at thin membrane areas, natural tendon tension visible. Dragon’s head lowered slightly, nostrils flaring, exhaling a realistic fire plume with heat distortion, light illuminating snow particles in the air. Knight in fur-lined, weathered armor with visible scratches and ice accumulation, gripping reins and raising sword naturally over his head, cape fluttering realistically. Snow and ice shards stirred by dragon wings and fire blast, frozen lake below with reflective cracks, jagged mountains and icy cliffs in the distance partially obscured by mist. Subtle overcast winter sunlight casting long soft shadows, realistic ambient occlusion on dragon and knight. Motion blur on wings and fire, fine snow particles catching light. Shot on a long telephoto lens, cinematic depth, grounded fantasy realism. No exaggerated floating poses, no stylized glowing eyes, dragon anatomy obeying weight and gravity, fire physically interacting with environment (melting snow, reflecting light on armor and scales).",
  },
  {
    src: "https://ik.imagekit.io/jeikuP/openart-image_QbSGa1ep_3040x5504_1768362774700.webp",
    alt: "elara",
    ratio: "9:16",
    prompt:
      "A full-body portrait of Elara Windrider facing the camera. She is a young adult woman with long silver hair, ice-blue eyes, and a confident expression. Her skin is fair with a few faint freckles across her nose. Elara wears a dark navy-blue leather jacket over a white tunic, black fitted pants, and knee-high leather boots. Her stance is strong and grounded with arms relaxed at her sides. The lighting is natural and soft, highlighting her sharp facial features and detailed clothing textures.",
  },
  {
    src: "https://ik.imagekit.io/jeikuP/hyperrealistic_cinematic_photograph_of_pedestrians_crossing_a%20(2).jpeg",
    alt: "pedestrians",
    ratio: "16:9",
    prompt:
      "Hyper-realistic cinematic photograph of pedestrians crossing a rain-soaked city street at night. Wet asphalt reflecting traffic lights, blurred headlights in the distance. Natural umbrellas, imperfect clothing folds, realistic water splashes near shoes. Subtle motion blur on moving subjects, sharp focus on central figure. Shot on a 35mm lens, handheld street photography style, authentic lighting and reflections, no stylization.",
  },
  {
    src: "https://ik.imagekit.io/jeikuP/hyperrealistic_cinematic_scene_of_two_futuristic_warriors.jpeg",
    alt: "robo-warriors",
    ratio: "16:9",
    prompt:
      "Hyper-realistic cinematic scene of two futuristic warriors dueling on a neon-lit rooftop at night. Rain falling, puddles reflecting vibrant neon lights of holograms and signs. One warrior in sleek cyber armor, the other in battle-worn mech-inspired suit, posed dynamically as if mid-attack. Soft fog and mist around their legs, subtle motion blur on raindrops and sparks from weapon clashes. Low-angle perspective emphasizing height and scale. Background: city skyscrapers glowing with neon, distant drones flying. Realistic textures: wet surfaces, reflections on armor, glowing weapons. Cinematic depth of field: focus on duel, city slightly blurred. Subtle lens flare from neon signs, grounded anatomy, realistic poses, natural physics.",
  },
  {
    src: "https://ik.imagekit.io/jeikuP/hyperrealistic_extreme_closeup_of_fabric_folds_with.jpeg",
    alt: "ring",
    ratio: "1:1",
    prompt:
      "Hyper-realistic extreme close-up of fabric folds with a ring or bracelet lying on it. Soft directional lighting emphasizing texture of metal and fabric. Shallow depth of field, subtle shadows, reflections, and ambient highlights. Angle slightly diagonal to create dynamic composition. Cinematic realism, tactile feel.",
  },
  {
    src: "https://ik.imagekit.io/jeikuP/hyperrealistic_fullbody_portrait_of_a_woman_in.jpeg",
    alt: "coffee",
    ratio: "9:16",
    prompt:
      "Hyper-realistic full-body portrait of a woman in a flowing evening gown, shot from above at a top-down angle. Subject seated or standing with gown spread elegantly, arms softly placed by side. Soft warm ambient lighting highlighting folds in fabric. Hair slightly splayed naturally, shadows creating depth. Minimalist background with shallow depth of field. Realistic skin, fabric texture, and subtle lighting interaction.",
  },
  {
    src: "https://ik.imagekit.io/jeikuP/hyperrealistic_cinematic_shot_of_a_sneaker_placed%20(1).jpeg",
    alt: "coffee",
    ratio: "16:9",
    prompt:
      "Hyper-realistic cinematic shot of a sneaker placed on a reflective studio floor. Texture details visible: mesh, leather, rubber sole. Natural light reflections on materials, subtle shadow under shoe. Slight tilt to show profile and sole simultaneously. Minimal background for focus on product. Realistic depth of field, no floating or distortion.",
  },
  {
    src: "https://ik.imagekit.io/jeikuP/hyperrealistic_closeup_of_a_modern_smartphone_on.jpeg",
    alt: "smartphone",
    ratio: "1:1",
    prompt:
      "Hyper-realistic close-up of a modern smartphone on a minimal reflective surface. Soft studio lighting highlighting brushed metal edges and glass screen reflections. Device slightly angled to show screen and edge. Subtle shadows for depth. Realistic material texture: glass, metal, buttons, camera lenses. No exaggerated glow or lens flare. Minimalist background in neutral tone. Shot with shallow depth of field to focus on product. Realistic reflections, soft ambient light.",
  },
  {
    src: "https://ik.imagekit.io/jeikuP/vinyl-records.jpeg",
    alt: "vinyl-records",
    ratio: "1:1",
    prompt:
      "Stack of vintage vinyl records with colorful album covers, arranged on a turntable, 12 inch LPs, record player, warm moody lighting, shallow depth of field, high quality image, hyper-realistic",
  },
];